import { render, staticRenderFns } from "./LomPresidentAssign.vue?vue&type=template&id=fb26f2fc"
import script from "./LomPresidentAssign.vue?vue&type=script&lang=js"
export * from "./LomPresidentAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports